/**
 * Код появился к проекту "Чёрная пятница" для компании "Этажи".
 * @todo: удалить в задаче CD-251228
 */
export interface IEtazhiBlackFridayPromoOffersData {
  desktop?: IEtazhiBlackFridayPromoOffersDataByPlatform;
  mobile?: IEtazhiBlackFridayPromoOffersDataByPlatform;
  minDiscount?: number;
}

export interface IEtazhiBlackFridayPromoOffersDataByPlatform {
  enabled?: boolean;
  startDate?: string;
  label?: IEtazhiBlackFridayLabel;
}

export type IEtazhiBlackFridayPricesData = Record<string, number>;

export interface IEtazhiBlackFriday {
  pricesData: IEtazhiBlackFridayPricesData | null;
}

export interface IEtazhiBlackFridayLabel {
  text: string;
  color: string;
}

export enum ELabelColor {
  Gray = 'gray',
  DarkGray = 'dark-gray',
  Green = 'green',
  DarkGreen = 'darkGreen',
  Red = 'red',
  Yellow = 'yellow',
  /** Оранжевый с иконкой процента */
  OrangePercent = 'orangePercent',
  /** Синий с иконкой Циан */
  Blue = 'blue',
  /** Синий без иконки Циан */
  SimpleBlue = 'simpleBlue',
  SurfaceBlueIconed = 'surfaceBlueIconed',
  SurfaceBlue = 'surfaceBlue',
  BlackBlueGradient = 'blackBlueGradient',
  BlueVerifiedByCian = 'blueVerifiedByCian',
  BlueInstantBooking = 'blueInstantBooking',
  /** Фиолетовый с иконкой */
  Purple = 'purple',
  Orange = 'orange',
  PurpleEarlyAccess = 'purpleEarlyAccess',

  /**
   * Код появился к проекту "Чёрная пятница" для компании "Этажи".
   * @todo: удалить в задаче CD-251228
   */
  RedEtazhiBlackFriday = 'redEtazhiBlackFriday',
}

export type TLabelColor = `${ELabelColor}`;

export interface IEtazhiBlackFridayDiscountColorsConfig {
  bgColor: string;
  color: string;
  strikethroughColor: string;
}
